import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GridPanelComponent
{
    @Input() withBorder: boolean = false;
    @Input() whiteBackground: boolean = false;
    @Input() classes: string = '';
}
